import React, { useEffect } from "react";
import cookie from "react-cookies";
import queryString from "query-string";

import { getInfo } from "../../model/reward";

import Session from "../common/session";
import Header from "../components/header";
import Footer from "../components/footer";
import AccountSideBar from "../account/components/accountsidebar";

import appstore from "../../static/images/landingpage/install/appstore.png";
import googleplay from "../../static/images/landingpage/install/playstore.png";

import empty from "../../static/images/empty/empty-gift.svg";

import * as ROUTES from "../../constant/routes";

const MyReward = (props) => {
	useEffect(() => {
		if (props.location && props.location.search) {
			const query = queryString.parse(props.location.search);
			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
		}

		window.scrollTo(0, 0);
	}, []);

	// const getInfoHandler = () => {
	// 	getInfo().then((resp) => {
	// 		if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
	// 			setMipoint(resp.data.data.mipoint);
	// 		}
	// 	});
	// };

	const onIOSAppClick = () => {
		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "INSTALL_APP_IOS", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		// window.ga("send", "event", utmSrc, "INSTALL_APP_IOS", utmExt);
		window.fbq("track", "INSTALL_APP_IOS");
	};

	const onAndrAppClick = () => {
		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "INSTALL_APP_ANDR", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		// window.ga("send", "event", utmSrc, "INSTALL_APP_ANDR", utmExt);
		window.fbq("track", "INSTALL_APP_ANDR");
	};

	let linkIOS = `${ROUTES.installIOS}` ;
	let linkAndroid = `${ROUTES.installAndroid}`;

	const utmSrc = cookie.load("_utm_src") || "Web2App";

	if (utmSrc !== "") {
			linkIOS = `${linkIOS}&campaign=${utmSrc}&utm_source=${utmSrc}`;
			linkAndroid = `${linkAndroid}&campaign=${utmSrc}&utm_source=${utmSrc}`;
	}

	return (
		<div className="mioto-layout">
			<Session />
			<Header />
			<section className="body">
				<div className="account-section sec space">
					<div className="m-container">
						<div className="account-container">
							<AccountSideBar />
							<div className="content-account">
								<div className="content-title">
									<h4>Quà tặng</h4>
								</div>
								<div className="empty-container">
									<img loading="lazy" src={empty} />
									<p>Bạn vui lòng sử dụng app Mioto để tìm hiểu thêm chi tiết chương trình</p>
									<div className="install-img d-flex">
										<a target="_blank" onClick={onIOSAppClick} href={linkIOS}>
											<img loading="lazy" src={appstore} />
										</a>
										<a target="_blank" onClick={onAndrAppClick} href={linkAndroid}>
											<img loading="lazy" src={googleplay} />
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</div>
	);
};

export default MyReward;
